import { supabase } from './supabase';

// Helper to get or create a visitor ID
const getVisitorId = () => {
    let vid = localStorage.getItem('site_visitor_id');
    if (!vid) {
        // Fallback if crypto.randomUUID is not available (e.g. non-HTTPS or older browsers)
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            vid = crypto.randomUUID();
        } else {
            vid = 'v-' + Math.random().toString(36).substring(2, 9) + '-' + Date.now().toString(36);
        }
        localStorage.setItem('site_visitor_id', vid);
    }
    return vid;
};

// Helper to check if user opted out (Admin)
const isAdminOptOut = () => {
    return localStorage.getItem('admin_opt_out') === 'true';
};

export const trackEvent = (eventName, params = {}) => {
    if (window.gtag) {
        window.gtag('event', eventName, params);
    } else {
        console.warn(`Gtag not found for event: ${eventName}`, params);
    }
};

export const trackContactClick = (type, propertyTitle = 'General') => {
    trackEvent('contact_click', {
        contact_type: type,
        property_name: propertyTitle
    });
};

export const trackPropertyView = (property) => {
    trackEvent('view_item', {
        items: [{
            item_id: property.id,
            item_name: property.title,
            item_category: property.type,
            price: property.price,
            location_id: property.city
        }]
    });
};

export const trackPageView = (path, title) => {
    // Google Analytics
    trackEvent('page_view', {
        page_path: path,
        page_title: title || document.title,
        page_location: window.location.href
    });

    // Supabase Custom Tracking
    trackSupabaseView(path, title || document.title);
};

export const trackSupabaseView = async (path, title) => {
    try {
        await supabase.from('site_stats').insert({
            site_target: 'scbi',
            page_path: path,
            page_title: title,
            visitor_id: getVisitorId(),
            is_admin: false
        });
    } catch (error) {
        console.warn('Supabase tracking error:', error);
    }
};
